import Image from 'next/legacy/image'
import LoaderGif from '@/assets/img/loader.gif'

function Loader({ size = 70 }) {
  return (
    <div aria-busy aria-live="polite">
      <Image src={LoaderGif} width={size} height={size} alt="loading" />
    </div>
  )
}

export default Loader
